import { render, staticRenderFns } from "./HistoricoTransferencia.vue?vue&type=template&id=8efed64a&"
import script from "./HistoricoTransferencia.vue?vue&type=script&lang=js&"
export * from "./HistoricoTransferencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/shared-components/workflow/HistoricoTransferencia.vue
// module id = 1073
// module chunks = 28